import { defineStore } from 'pinia/dist/pinia'
import { loadMapChartData } from '@/service/Versorgungsatlas'
import { fillDataArraysMap } from '@/service/Versorgungsatlas'

export const useEvaluationMapStore = defineStore('evaluationMapList', {
    state: () => ({
        evaluationMapList: [],
        latestYear: 0,
        auswid: 0,
    }),
    getters: {
        getEvaluationById: (state) => {
            return (auswid) => state.evaluationMapList.find((evaluation) => parseInt(evaluation.auswid) === parseInt(auswid))
        },
        getLatestYear: (state) => {
            return (auswid) => state.update(auswid);
        }
    },
    actions: {
        update(auswid) {
            if (this.auswid != auswid) {
                this.loadMapChartData(auswid, true);
            }

            return this.latestYear;
        },
        updateStates(auswid) {
            //this.evaluationAgeList enthält user_ziva_werte
            // zu einer auswid mit ausprids zwischen 1 und 10 entsprechend den Altersgruppen
            // für alle Männer und Frauen
            // für mehrere Jahre
            let result = fillDataArraysMap(this.evaluationMapList);

            this.latestYear = result[0]['latestYear'];
            this.auswid = auswid;
        },
        async loadMapChartData(auswid, force = false) {
            if ((this.evaluationMapList?.length === 0) || force === true) {
                const resultSetAge = await loadMapChartData(auswid)
                this.evaluationMapList = resultSetAge.data ?? []
            }

            this.updateStates(auswid)
        },
    },
})